import { render, staticRenderFns } from "./studentEdit.vue?vue&type=template&id=b1f34956&scoped=true&"
import script from "./studentEdit.vue?vue&type=script&lang=ts&"
export * from "./studentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./studentEdit.vue?vue&type=style&index=0&id=b1f34956&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f34956",
  null
  
)

export default component.exports